import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { CheckoutStepComponentDef } from '@df/checkout/checkout-step.component.def';
import { App } from '@df/core/app';
import { TimeoutService } from '@df/ng/timeout.service';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { MuiInputDirective } from '../../ui/form/mui-input.directive';
import { RadioComponent } from '../../ui/form/radio';
import { CheckoutFormComponent } from './../../checkout/checkout-form.component';
import { CheckoutDeliveryQuestionsComponentDef } from './checkout-delivery-questions.component.def';

@Component({
    selector: 'checkout-delivery-questions',
    templateUrl: './checkout-delivery-questions.html',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        InputWrapBodyDirective,
        InputWrapComponent,
        MuiInputDirective,
        RadioComponent,
        RadioGroupDirective,
        TranslatePipe
    ],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutDeliveryQuestionsComponent extends CheckoutDeliveryQuestionsComponentDef {
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        checkoutStepComponent: CheckoutStepComponentDef,
        app: App,
        changeDetectorRef: ChangeDetectorRef,
        timeoutService: TimeoutService
    ) {
        super(checkoutFormComponent, checkoutStepComponent, app, changeDetectorRef, timeoutService);
    }
}
